export default {
  load() {
    $('.input-group input, .input-group label')
      .addClass('no-focus');

    $(document).on('focus', '.input-group input, .input-group label', function() {
      $(this).parents('.input-group').addClass('focus');
    });
    $(document).on('blur', '.input-group input, .input-group label', function() {
      $(this).parents('.input-group').removeClass('focus');
    });
  },
  loadSearch() {
    $(document).on('click', '#js-top-bar-search', function(e) {
      $(this).toggleClass('open');
      $('.top-bar-search').toggleClass('open');

      e.preventDefault();
      e.stopPropagation();
    });
  },
}



// WEBPACK FOOTER //
// ./scripts/util/global.js